import {createAction, props} from '@ngrx/store';

export const fetchTopPromotions = createAction(
  '[TopList] Fetch Top Promotions',
  props<{ payload }>()
);

export const fetchTopPromotionsToolsSuccess = createAction(
  '[TopList] Fetch Top Promotions Success',
  props<{ data }>()
);

export const fetchTopPromotionsToolsFailure = createAction(
  '[TopList] Fetch Top Promotions Error',
  props<{ error }>()
);

export const fetchTopDownlines = createAction(
  '[TopList] Fetch Top Downlines',
  props<{ payload }>()
);

export const fetchTopDownlinesSuccess = createAction(
  '[TopList] Fetch Top Downlines Success',
  props<{ data }>()
);

export const fetchTopDownlinesFailure = createAction(
  '[TopList] Fetch Top Downlines Error',
  props<{ error }>()
);
